import React from 'react';
import {SourcesSectionPortalOutlet} from './SourcesSectionReversePortal';

/**
 * Consolidated, three-store unified search surface (M6A) that replaces the legacy
 * corpus-only `SearchSection`.
 *
 * Renders the shared {@link SourcesSection} (search header + filters + federated results)
 * through the reverse-portal outlet so the Search tab and the My files tab drive the same
 * live instance. When no portal provider is mounted (e.g. pitch / disclosure left panels,
 * the source-package search panel) the outlet falls back to rendering `SourcesSection`
 * directly.
 *
 * @param {{hostId?: string, isActive?: boolean}} props
 */
const UnifiedSearchSection = ({hostId = 'unified-search-section', isActive = true}) => (
    <SourcesSectionPortalOutlet hostId={hostId} isActive={isActive}/>
);

export default UnifiedSearchSection;
